<script>
import axios from 'axios'
import { VueEditor, Quill } from 'vue2-editor'
import { mapGetters } from 'vuex'
export default
{
    name: 'mv-place-form',

    components: { VueEditor },

    props:
    {
        model: Object,
        edit: Boolean,
    },

    computed:
    {
        cityValue:
        {
            get()
            {
                return this.cities.findByModelId(this.model.city_id)
            },

            set(val)
            {
                if (val && val.id)
                    this.model.city_id = val.id
            },
        },

        ...mapGetters({ locale: 'generalCurrentLocale', types: 'generalLocationTypes'}),

    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },

        locAddressChange(obj)
        {
            this.model.location = obj
        },

        fetchCities()
        {
            axios.get(process.env.API_URL + '/v1/admin/locationcities').then(({data}) => {
                const filteredData = (data ? data.filter((item) => item.name) : [])
                this.cities = filteredData
            })
        },

        syncPrograms()
        {
            axios.post(process.env.API_URL + `/v1/admin/locations/${this.model.id}/sync`)
        },

        publishPrograms()
        {
            axios.post(process.env.API_URL + `/v1/admin/locations/${this.model.id}/publish`)
        },

        unPublishPrograms()
        {
            axios.post(process.env.API_URL + `/v1/admin/locations/${this.model.id}/unpublish`)
        },

    },

    data()
    {
        return {
            cities: [],
            editorSettings: {
                imageResize: {},
            },
        }
    },

    mounted()
    {
        this.fetchCities()
    },

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('PLACE.NAME') }}
            </label>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1">
                        <img src="/static/hu-flag.png" alt="Magyar" title="Magyar" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.name">
                </div>
            </div>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon2">
                        <img src="/static/us-flag.png" alt="English" title="English" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.name_en" >
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('PLACE.CITY') }}
            </label>
            <div class="col-md-6">
                <v-select :options="cities" v-model="cityValue" label="name">
                    <template slot="option" slot-scope="option">
                        <div class="row option-row">
                            <div class="col-sm-2 hidden-sm hidden-xs">
                                <div v-if="option.attachments && option.attachments.length">
                                    <img :src="option.attachments[0].thumbnail_url">
                                </div>
                            </div>
                            <div class="col-sm-10">
                                <div class="text">
                                    {{ option.name }}
                                </div>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.IMAGES') }}
            </label>
            <div class="col-md-6">
                <mv-image-uploader ref="uploader" multiple @upload-done="addFile($event)" accept="image/*"></mv-image-uploader>
            </div>
        </div>

        <div class="form-group row">
            <div class="col-md-4">

            </div>
            <div class="col-md-6">
                <mv-attachment v-for="img in model.attachments" :key="img.id" :attachment="img" can-remove @remove="removeFile">
                </mv-attachment>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('PLACE.ADDRESS') }}
            </label>
            <div class="col-md-6">
                <mv-address @locationChange="locAddressChange" v-model="model.address"></mv-address>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('PLACE.LOCATION') }}
            </label>
            <div class="col-md-6">
                <mv-map v-model="model.location"></mv-map>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.ON_SITE')}}
            </label>
            <div class="col-md-6">
                <input type="checkbox" v-model="model.on_site">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.ON_MOBILE')}}
            </label>
            <div class="col-md-6">
                <input type="checkbox" v-model="model.on_mobile">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.ON_MAP')}}
            </label>
            <div class="col-md-6">
                <input type="checkbox" v-model="model.on_map">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('PLACE.TYPE')}}
            </label>
            <div class="col-md-6">
                <select v-model="model.location_type_id" class="form-control">
                    <option v-for="type in types" :key="type.id" :value="type.id"> {{ type.name }}</option>
                </select>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('PLACE.MARKER_POS')}}
            </label>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-6">
                        <input class="form-control" v-model="model.marker_x">
                    </div>
                    <div class="col-md-6">
                        <input class="form-control" v-model="model.marker_y">
                    </div>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('PLACE.MARKER_COLOR')}}
            </label>
            <div class="col-md-6">
                <select v-model="model.marker_icon" class="form-control">
                    <option value="barna">Barna</option>
                    <option value="kek">Kék</option>
                    <option value="rozsaszin">Sárga</option>
                    <option value="zold">Zöld</option>
                </select>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('PLACE.MARKER_DIR')}}
            </label>
            <div class="col-md-6">
                <select v-model="model.marker_direction" class="form-control">
                    <option value="left">{{ $t('GENERAL.LEFT') }}</option>
                    <option value="right">{{ $t('GENERAL.RIGHT') }}</option>
                </select>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('PLACE.DESCRIPTION')}}
            </label>
            <div class="col-md-6">
                <vue-editor
                    v-if="locale == 'hu'"
                    :editorOptions="editorSettings"
                    v-model="model.description">
                    </vue-editor>
                <vue-editor
                    v-else
                    :editorOptions="editorSettings"
                    v-model="model.description_en">
                    </vue-editor>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                Google Sheet ID
            </label>
            <div class="col-md-6">
                <input class="form-control" v-model="model.programs_sheet_document_id">
                <button class="btn btn-primary" @click="syncPrograms">Sync Programs</button>
                <button class="btn btn-secondary" @click="publishPrograms">Publish All Programs</button>
                <button class="btn btn-secondary" @click="unPublishPrograms">Unpublish All Programs</button>
            </div>
        </div>

    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/forms/PlaceForm.vue